/**
 * Режим встраивания: страница рендерится без сайдбара, шапки и виджета
 * ассистента.
 *
 * Нужен для предпросмотра внутри чата (AssistantLinkCard). Раньше туда
 * грузилось полное приложение: в рамке 260px пользователь видел сайдбар,
 * шапку и вторую копию кнопки чата — то есть почти всё, кроме самой
 * страницы, ради которой предпросмотр и открывался.
 *
 * Признак — query-параметр `?embed=1`. Именно query, а не отдельный
 * маршрут: у каждой страницы остаётся один адрес, и ссылка из чата
 * ведёт туда же, куда обычная навигация.
 *
 * Флаг читается из `window.location` напрямую, без роутера: он нужен и
 * в модулях вне дерева React, и до первого рендера.
 */

/** Страница открыта внутри рамки предпросмотра. */
export function isEmbedMode() {
  if (typeof window === "undefined") return false;
  try {
    return new URLSearchParams(window.location.search).get("embed") === "1";
  } catch (e) {
    return false;
  }
}

/** Добавляет `embed=1` к пути роутера, сохраняя уже имеющиеся параметры. */
export function withEmbedParam(routerPath) {
  const [pathAndQuery, hash] = String(routerPath || "/").split("#");
  const [path, query] = pathAndQuery.split("?");
  const params = new URLSearchParams(query || "");
  params.set("embed", "1");
  return path + "?" + params.toString() + (hash ? "#" + hash : "");
}

/** Убирает `embed=1` — по этой ссылке страница открывается целиком. */
export function withoutEmbedParam(routerPath) {
  const [pathAndQuery, hash] = String(routerPath || "/").split("#");
  const [path, query] = pathAndQuery.split("?");
  const params = new URLSearchParams(query || "");
  params.delete("embed");
  const rest = params.toString();
  return path + (rest ? "?" + rest : "") + (hash ? "#" + hash : "");
}
